module.exports = __webpack_public_path__ + "img/pl5_bg.6f8ab051.png";